import React, { useState } from "react";
import "./postModal.css";
import API from "../../../api";

export default function PostModal({ onClose, addToFeed }) {
  const [text, setText] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handlePost = async () => {
  if (!localStorage.getItem("token")) {
    return alert("Please login");
  }

  if (!text.trim()) {
    return alert("Post content required");
  }

  try {
    setLoading(true);

    const formData = new FormData();
    formData.append("text", text);
    formData.append("type", "post");

    if (imageFile) {
      formData.append("image", imageFile);
    }

    const res = await API.post("/post/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    if (res.data.success) {
      addToFeed(res.data.post);
      onClose();
    } else {
      alert("Failed to post");
    }
  } catch (err) {
    console.error("POST ERROR", err);
    alert("Server error");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="vendor-modal-overlay">
      <div className="post-modal-card">

        <h3>Create Post</h3>

        <textarea
          placeholder="Share something with the Civilink community…"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            setImageFile(file);
            if (file) {
              setPreview(URL.createObjectURL(file));
            }
          }}
        />

        {preview && (
          <img src={preview} alt="preview" className="post-preview" />
        )}

        <div className="post-actions">
          <button className="btn-outline" onClick={onClose}>
            Cancel
          </button>

          <button
            className="btn-primary"
            onClick={handlePost}
            disabled={loading}
          >
            {loading ? "Posting..." : "Post"}
          </button>
        </div>

      </div>
    </div>
  );
}
